import { useWeb3React } from '@web3-react/core';
import { Children, cloneElement, useContext, useMemo, useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { useHistory } from 'react-router-dom';
import { SupportedChains } from '../../config/constants';
import themeContext from '../../context/theme/themeContext';
import Dropdown from '../Dropdown';
import tabsContext from './tabsContext';

export const TabHeader: React.FC = ({ children }) => {
    const { theme } = useContext(themeContext);

    const { chainId } = useWeb3React();

    const { tabIndex, setTabIndex } = useContext(tabsContext);

    const [open, setOpen] = useState(false);

    const history = useHistory();

    const toggle = () => setOpen((prev) => !prev);

    const hide = () => {
        if (!open) return;

        setOpen(false);
    };

    const allChildren = Children.map(children, (child: any, index) => {
        if (!child) return;
        const clone = cloneElement(child, {
            active: tabIndex === index,
            onClick: () => {
                setTabIndex(index);
                hide();

                child?.props?.to &&
                    history.push(
                        child.props.to +
                            `${
                                chainId === SupportedChains.ARBITRUM_ONE
                                    ? '?network=arbitrum'
                                    : ''
                            }`
                    );
            },
        });

        return clone;
    });

    const activeClone = useMemo(
        () =>
            Children.toArray(children)
                .filter((_, i) => i === tabIndex)
                .map((child: any) =>
                    cloneElement(child, {
                        onClick: toggle,
                    })
                ),
        [children, tabIndex]
    );

    return (
        <ClickAwayListener onClickAway={hide}>
            <div className={`tabs-header-container ${theme}`}>
                {activeClone}
                <Dropdown open={open}>{allChildren}</Dropdown>
            </div>
        </ClickAwayListener>
    );
};

export default TabHeader;
